import React from "react";
import * as Sentry from "@sentry/react";
import { useAnalytics, ActionType } from "utils/analytics/AnalyticsContext";
import NoPII from "utils/NoPII";

export default function ErrorBoundary(props: {
  component: string;
  errorContext?: Record<string, string | number | boolean | null | undefined>;
  fallback?: () => React.ReactElement;
  children: React.ReactNode;
}) {
  const { trackEvent } = useAnalytics("ErrorBoundary");

  return (
    <Sentry.ErrorBoundary
      onError={(error, componentStack) => {
        trackEvent({
          eventName: "react_rendering_error",
          eventType: ActionType.ERROR,
          extraProperties: {
            extraMetadata: {
              ...props.errorContext,
              component: NoPII(props.component),
              componentStack: NoPII(componentStack, {
                allowWhitespace: true,
              }),
              errorName: NoPII(error.name),
            },
          },
        });
      }}
      fallback={props.fallback || DefaultError}
    >
      {props.children}
    </Sentry.ErrorBoundary>
  );
}

function DefaultError() {
  return (
    <p>Sorry, something went wrong. Please refresh the page to try again.</p>
  );
}
